import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import { StatementRuleConfiguration } from "../../rule-engine-core/Rule/Statement/StatementRuleConfiguration";
import { IContext } from "../../rule-engine-core/Common/IContext";
import { IDesignPanelConfig } from "../../rule-engine-core/Common/IDesignPanelConfig";
import { RuleBuilderPage } from "../../rule-engine-core/Rule/RuleBuilderPage";
import { DialogProps } from "../../rule-engine-core/Common/DialogProps";
import { ILinkingData } from "../../rule-engine-core/Rule/ILinkingData";

export class StatementRuleEditContext implements IContext {
    designConfig?: IDesignPanelConfig | undefined;
    runtimeConfig?: IDesignPanelConfig | undefined;
    clipboardElement: any;
    lastSelectionElement: any;

    mode: RuleBuilderPage = RuleBuilderPage.Rule;

    definition: StatementRuleConfiguration;

    title?: string;
    public onRuleSave?: () => void;
    public onRuleCancel?: () => void;
    _openLinkingDialog: boolean = false;

    constructor(rule: StatementRuleConfiguration) {
        this.definition = rule;
    }

    _notification: DialogProps | undefined;

    get notification() {
        return this._notification;
    }

    set notification(notification: DialogProps | undefined) {
        this._notification = notification;
        StateManager.propertyChanged(this, "notification");
    }

    get openLinkDialog() {
        return this._openLinkingDialog;
    }

    set openLinkDialog(open: boolean) {
        this._openLinkingDialog = open;
        StateManager.propertyChanged(this, "openLinkDialog");
    }

    _linkData: ILinkingData = {
        period: "every_day",
        periodData: {
            period: "day",
            times: 0,
            onWeekDays: [],
            at: "1",
            value: 1,
        },
        storeData: true,
        serviceSetting: false,
        format: "csv",
    };

    get linkData() {
        return this._linkData;
    }

    set linkData(data: ILinkingData) {
        this._linkData = data;
        StateManager.propertyChanged(this, "linkData");
    }

    @AutoBind
    onSave() {
        if (this.title) {
            this.definition.title = this.title;
        }

        if (this.onRuleSave) {
            this.onRuleSave();
        }
    }

    @AutoBind
    onCancel() {
        this.title = this.definition.title;
        if (this.onRuleCancel) {
            this.onRuleCancel();
        }
    }

    // eslint-disable-next-line
    onCopy(id?: string) {}

    // eslint-disable-next-line
    onCut(id?: string) {}

    // eslint-disable-next-line
    onDelete(id?: string) {}

    // eslint-disable-next-line
    onPaste(id?: string) {}
}
